import { Component, ElementRef, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { AuthService, LocalizeService } from '../../insa-services'
import { SharedMethodsModule } from '../../insa-custom-scripts'

@Component({
  templateUrl: 'resetPassword.component.html'
})
export class ResetPasswordComponent implements OnInit {
  newPassword: string = "";
  confirmPassword: string = "";
  submitted: boolean = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _localize: LocalizeService,
    private _element: ElementRef,
  ) { }

  ngOnInit(): void {
    // Only reachable right after a successful 2FA/certificate verification
    // for a 'reset' purpose - if there's no reset token, bounce to login
    // rather than showing a form with nothing to submit against.
    if (!this._authService.getResetToken()) {
      this._router.navigate(['/login']);
    }
  }

  onSubmit(form: any): void {
    if (form['newPassword'] !== form['confirmPassword']) {
      SharedMethodsModule.addNotification(
        "#notificationResetPassword",
        this._localize.getTranslation('Lozinke nisu iste!'),
        false
      );
      return;
    }

    this.submitted = true;
    kendo.ui.progress($(".main-loading"), true);

    this._authService.resetPassword(this._authService.getResetToken(), form['newPassword'])
      .subscribe({
        next: () => {
          kendo.ui.progress($(".main-loading"), false);

          // Success: token is now spent, clear it locally (backend should
          // also invalidate it server-side) and land the user back on
          // /login - deliberately NOT logged in, per design.
          this._authService.clearResetToken();

          this._router.navigate(['/login']).then(() => {
            SharedMethodsModule.addNotification(
              "#notification",
              this._localize.getTranslation('Lozinka je uspešno promenjena. Prijavite se novom lozinkom.'),
              true
            );
          });
        },
        error: (err) => {
          kendo.ui.progress($(".main-loading"), false);

          // Failure: stay on this screen, do NOT clear the reset token
          // (so the user can retry without redoing the whole 2FA
          // challenge) and do NOT navigate away.
          this.submitted = false;
          SharedMethodsModule.addNotification(
            "#notificationResetPassword",
            err?.error?.message || this._localize.getTranslation('Nije moguće resetovati lozinku. Pokušajte ponovo.'),
            false
          );
        }
      });
  }

  ngAfterViewInit() {
    this._localize.applyTranslations(this._element.nativeElement, 'LOOKUP');
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/resetPassword.component.ts